import React, { Component } from 'react';

import FlashCardStack from './FlashCardStack';
import FlashCardGrid from './FlashCardGrid';

class QuizFamily extends Component {
  render() {
    const {
      lesson: { variant }
    } = this.props;
    switch (variant) {
      case 'flashcardStack':
        return <FlashCardStack {...this.props} />;
      case 'flashcardGrid':
        return <FlashCardGrid {...this.props} />;
      default:
        return null;
    }
  }
}

export default QuizFamily;
